import useSWR from "swr";
import { Container, Grid, Heading, Text, Flex, Stack } from "@chakra-ui/react";
import Resume from "../../components/Card/Resume";
import bg1 from "../../assets/new-images/backgrounds/image1.png";
import baseService from "../../services/base";
import { useSSO } from "../../context/SSO";
import Loader from "../../components/Feedback/Loader";

async function fetchSurvey(url) {
  const response = await baseService.get(url);
  return response?.data;
}

export default function Analysis() {
  const { user } = useSSO();

  const { data: companies, isLoading } = useSWR(
    user?.user?.id_user ? `company/admin_company/${user?.user?.id_user}` : null,
    fetchSurvey
  );

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container maxW="container.xl" position="relative" px={0}>
      <Stack bg="white" p="32px" borderRadius="12px">
        <Heading fontSize="24px" fontWeight={700}>
          Revisão
        </Heading>
      </Stack>

      {companies?.length === 0 && (
        <Flex py="14px" mt="32px">
          <Text fontSize="15px" fontWeight={500}>
            Nenhuma pesquisa disponível para avaliação.
          </Text>
        </Flex>
      )}
      <Grid templateColumns="repeat(2, 1fr)" gap={"12px"} mt="32px">
        {companies?.map((company, index) => (
          <Resume
            key={index}
            title={company?.name}
            subtitle={company?.cnpj?.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
              "$1.$2.$3/$4-$5"
            )}
            bg={bg1}
            link={`/survey-analysis/${company?.id_company}`}
            linkLabel="Revisar respostas"
          />
        ))}
      </Grid>
    </Container>
  );
}
